import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PagingResource } from "../common";
import { DocumentTypesResource } from "../models/document-types-resource.model";

@Injectable({ providedIn: "root" })
export class DocumentTypesService {
    private httpClient = inject(HttpClient);

    public getDocumentTypes$(params: PagingResource = {}): Observable<DocumentTypesResource> {
        const httpParams = new HttpParams({
            fromObject: Object.fromEntries(
                Object.entries(params)
                    .filter(([, value]) => value !== undefined && value !== null)
                    .map(([key, value]) => [key, String(value)])
            ) as Record<string, string>
        });

        return this.httpClient.get<DocumentTypesResource>("/api/documenttypes", { params: httpParams });
    }
}
